import styles from "./Hero.module.scss";

export const Hero = function ({ scrollTo }) {
  return (
    <section id="form" className={styles.hero}>
      <div className={styles.heroContainer}>
        <h1>
          ARTIFICIAL INTELLIGENCE:
          <br />
          IMPLICATIONS FOR BUSINESS STRATEGY
        </h1>
        <small>ONLINE SHORT COURSE</small>
        <p>
          Generative AI platforms have reshaped the way we do business. Deepen your knowledge of new tools and
          technologies, and learn how AI can be integrated into your organization to drive growth.
        </p>
        <br />
        <p>
          Now updated with the latest, most relevant insights on generative AI from leading MIT experts. Join 30,000+
          leaders who have already updated their expertise with Artificial Intelligence: Implications for Business
          Strategy.
        </p>
        <button onClick={scrollTo} id="cta-scroll">
          GET MORE INFORMATION
        </button>
      </div>
    </section>
  );
};
